import { useDispatch, useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { getContentKeyAccToLang, showToast } from '../../utils/utils';
import {
  cancelTransaction,
  getInvoiceReport,
  getSearchByType,
  getTransactions,
} from '../../store/actions/fund-action';
import dayjs from 'dayjs';
import { setTransactions } from '../../store/slices/fund-slice';
import { downloadBase64File } from '../../utils/functions';
import { transactionTabs } from '../../config/config';
import { getTransactionHistory } from '../../store/actions/transferAction';

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic, direction } = dynamicfunction();
  const { fundsContent } = useSelector((state) => state.content);
  const [selectedTab, setSelectedTab] = useState(transactionTabs?.[0]);
  const {
    transactions,
    search_types,
    fund_loading,
    downlaod_fund_trans_document,
    fund_document_loading,
  } = useSelector((state) => state.fund);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedType, setSelectedType] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCancelModal, setIsCancelModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  useEffect(() => {
    dispatch(setTransactions([]));
    dispatch(getTransactionHistory(`${selectedTab?.key}`))
    // dispatch(
    //   getSearchByType((data) => {
    //     setSelectedType(data?.[0]);
    //     dispatch(getTransactions(null, null, data?.[0]?.typeId));
    //   })
    // );
  }, []);

  const onPressTab = (item) => {
    setSelectedTab(item)
    dispatch(getTransactionHistory(`${item?.key}`))
  }

  const toogleCancelModal = () => setIsCancelModal(!isCancelModal);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_funds_transaction?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleGetTransactions = () => {
    const start_date = startDate ? dayjs(startDate).format('YYYY-MM-DD') : ""
    const end_date = endDate ? dayjs(endDate).format('YYYY-MM-DD') : ""
    const params = `${selectedTab?.key}&ActionType=${selectedType?.id ?? ""}&ToDate=${end_date}&FromDate=${start_date}`
    dispatch(getTransactionHistory(params));
  };

  const handleCancelTransaction = () => {
    const api_data = {
      id: selectedTransaction?.id,
      type: selectedTransaction?.type,
    };
    dispatch(
      cancelTransaction(api_data, () => {
        toogleCancelModal();
        handleGetTransactions();
      })
    );
  };

  const handleDownlaodFundTransDocument = async (invoiceId) => {
    dispatch(
      getInvoiceReport(invoiceId, (data) => {
        downloadBase64File({
          base64Data: data?.result?.base64MemoryStream,
          fileName: data?.result?.filename,
          fileType: 'application/pdf',
        });
      })
    );
  };
  const onPressReset = () => {
    setSelectedType(null);
    setStartDate(null);
    setEndDate(null);
    dispatch(getTransactionHistory(selectedTab?.key));

  }

  return {
    TextWeight,
    isArabic,
    fund_loading,
    isModalOpen,
    transactions,
    search_types,
    selectedType,
    handleGetTransactions,
    setSelectedType,
    setIsModalOpen,
    setStartDate,
    setEndDate,
    getContentKey,
    isCancelModal,
    toogleCancelModal,
    setSelectedTransaction,
    handleCancelTransaction,
    direction,
    handleDownlaodFundTransDocument,
    fund_document_loading,
    selectedTab,
    onPressTab,
    startDate,
    endDate,
    onPressReset
  };
};
